// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"app_iframeContainer__Dw6SW"};